import useQueryParentLayer from "../chain/store/useStoreLayerParent";


const stacks = []
const SHOW_LOG = false;

const useLogStack = (key, layer, content) => {
    if (!SHOW_LOG) { return }
    stacks.push([key, content]);
    const parent = useQueryParentLayer(layer);
    console.log('[LogStack]', key, parent, layer, content)
}

export default useLogStack;